import angular from "angular";
import { Util } from "@common/util";
import { TeamTypeEnum } from "@common/model/subject";
import { PopUpService } from "../popup.service";
import { ConditionalModuleLoadService } from "@common/service/conditionalModuleLoad.service";

export class AssociateTeamsToProjectController {

    static $inject = ["$q", "$uibModalInstance", "$uibModal", "project", "$state", "CacheService", "$injector", "ApiAdapterService",
        "$rootScope", "PopUpService", "PaymentService", "BroadcastService", "SubjectService", "ConditionalModuleLoadService"];

    constructor($q, $uibModalInstance, $uibModal: angular.ui.bootstrap.IModalService, project, $state, $_cache, $injector,
        private ApiAdapterService, $rootScope, $_pop: PopUpService, private PaymentService, BroadcastService,
        private $_subject, private ConditionalModuleLoadService: ConditionalModuleLoadService) {
        var associateTeamsVm: any = this;
        associateTeamsVm.util = Util;
        associateTeamsVm.project = project;
        associateTeamsVm.recipients = [];
        associateTeamsVm.newCRAdded = false;
        associateTeamsVm.teamLimitValid = false;
        associateTeamsVm.allTeams = [];
        associateTeamsVm.teamsFilter = {
            "isFormerTeamMember": false,
            "isFrozen": false,
            "subjectTypeId": TeamTypeEnum.CARE_RECIEPIENT
        };

        var setProviders = () => {
            // to pre-select the providers in the dropdown options
            if (!!associateTeamsVm.project.associatedSubjects) {
                associateTeamsVm.project.associatedSubjects.forEach(pr => {
                    associateTeamsVm.recipients.push(pr);
                });
            }
            if (associateTeamsVm.allTeams.length > 0) {
                associateTeamsVm.allTeams.forEach(t => {
                    if (!!associateTeamsVm.recipients.find(x => x.subjectId == t.subjectId)) {
                        t.selected = true;
                    }
                })
            }
        }

        associateTeamsVm.isTeamLimitValid = () => {
            PaymentService.checkLimitAndProceed("team", () => {
                associateTeamsVm.teamLimitValid = true;
            }, true);
        }
        associateTeamsVm.isTeamLimitValid();

        if (!associateTeamsVm.project.associatedSubjects || associateTeamsVm.project.associatedSubjects.length == 0) {
            this.ApiAdapterService.getSubject(associateTeamsVm.project.subjectId, $_cache.getPassword()).then((sub) => {
                associateTeamsVm.project.associatedSubjects = sub.associatedSubjects;
                setProviders();
            });
        } else {
            setProviders();
        }


        associateTeamsVm.exactSearchInList = (list, search, attr?) => {
            return !!(list || []).find(itm => attr ? itm[attr] == search : itm == search);
        }

        associateTeamsVm.addNewCR = (event, searchStr: string) => {
            this.ConditionalModuleLoadService.getCreateTeamService().then((CreateTeamService) => {
                const fn = function () {
                    return 'CR';
                };
                CreateTeamService.openAddNewCRPopup(fn, associateTeamsVm.project.subjectId)
                .then(function (s) {
                    associateTeamsVm.newCRAdded = true;
                    associateTeamsVm.recipients.push(s);
                    s.selected = true;
                    const successMsg = Util.ADD_CR_SUCCESS.replace('$subjectFullName', s.fullName);
                    toastr.success(successMsg);
                    associateTeamsVm.isTeamLimitValid();
                },
                function (e) {
                });
            });
        }

        associateTeamsVm.close = () => {
            $uibModalInstance.dismiss({ crAdded: associateTeamsVm.newCRAdded });
        }

        associateTeamsVm.associate = () => {
            var deferred = $q.defer();
            var subjList = "";
            for (var i = 0; i < associateTeamsVm.recipients.length; i++) {
                subjList += associateTeamsVm.recipients[i].subjectId + " ";
            }
            associateTeamsVm.ApiAdapterService.associateTeamsToProject(associateTeamsVm.project.projectId, subjList).then((s) => {
                $rootScope.mainShowLoader = null;
                toastr.success(Util.ASSOCIATE_TEAM_PROJECT);
                $uibModalInstance.close({ crAdded: associateTeamsVm.newCRAdded, subjects: s });
                deferred.resolve();
            },
                (e) => {
                    $rootScope.mainShowLoader = null;
                    console.log(e);
                    toastr.success(Util.FAILURE_MSG);
                    $uibModalInstance.close(false);
                    deferred.reject();
                });
            return deferred.promise;
        }

        associateTeamsVm.deselectRecipient = (deselectedRecipient, $event) => {
            let subId;
            if (!!deselectedRecipient.person) {
                subId = deselectedRecipient.person.subjectId;
                deselectedRecipient.person.selected = false;
            } else {
                subId = deselectedRecipient.subjectId;
                deselectedRecipient.selected = false;
            }
            associateTeamsVm.recipients = associateTeamsVm.recipients.filter((recipient) => {
                return recipient.subjectId != subId;
            });
        }
    }
}

angular.module('eCareVault.common.popUp')
    .controller('AssociateTeamsToProjectController', AssociateTeamsToProjectController);
